module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/endmatter02"
    }
  }, [_vm._v("Publisher’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_vm._v("ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_c('i', [_vm._v("Piecing")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002"
    }
  }, [_c('i', [_vm._v("Heirloom")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Death Benefits")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Nature’s Garden")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Peony")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Three Definitions of Poetry")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Battery")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Two by Two")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Phobophilia")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Ruining of the Work")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Duel: A Masque")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FOUR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Documentary")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Aerial View")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Elegy")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("White Sound")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Fall of a Sparrow")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Harrowing of Heaven")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Three Salt Sonnets to an Incidental Lover")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Undead: A Pentode of Seasons")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Depth Perception")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Hallowing of Hell")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0